var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect2, _rect3, _rect4, _path0, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoster192(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_811)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170 0H22C9.84974 0 0 9.84973 0 22V170C0 182.15 9.84973 192 22 192H170C182.15 192 192 182.15 192 170V22C192 9.84974 182.15 0 170 0Z",
    fill: "#00374D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.28 38.3999L0.0192261 75.8399V139.872L36.1344 110.169H89.0304H43.2L76.8 78.7199L41.28 38.3999Z",
    fill: "url(#paint0_linear_115_811)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.875 65.7983L65.664 110.17H36.2496L0.134426 139.872L0.0192261 146.995V169.942C0.0192261 182.093 9.86896 191.942 22.0192 191.942H85.8048L158.227 132.365V110.17L113.875 65.7983Z",
    fill: "url(#paint1_linear_115_811)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.917 110.17V88.0128H158.093L135.917 65.8176H113.76V110.17H36.1344V132.461H47.2128C47.3794 135.291 48.6211 137.951 50.684 139.896C52.7469 141.841 55.4751 142.925 58.3104 142.925C61.1457 142.925 63.8739 141.841 65.9368 139.896C67.9997 137.951 69.2414 135.291 69.408 132.461H74.88C75.0466 135.291 76.2883 137.951 78.3512 139.896C80.4141 141.841 83.1423 142.925 85.9776 142.925C88.8129 142.925 91.5411 141.841 93.604 139.896C95.6669 137.951 96.9086 135.291 97.0752 132.461H124.8C124.967 135.291 126.208 137.951 128.271 139.896C130.334 141.841 133.062 142.925 135.898 142.925C138.733 142.925 141.461 141.841 143.524 139.896C145.587 137.951 146.829 135.291 146.995 132.461H158.093V110.17H135.917Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.11 142.982V132.365H124.762V142.982H147.11Z",
    fill: "url(#paint2_linear_115_811)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2288 142.982V132.365H74.88V142.982H97.2288Z",
    fill: "url(#paint3_linear_115_811)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3488 142.982V132.365H46.08V142.982H70.3488Z",
    fill: "url(#paint4_linear_115_811)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.76 110.17H158.093V87.9937H113.76V110.17Z",
    fill: "url(#paint5_linear_115_811)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.093 110.17V88.0129H135.936V110.17H158.093Z",
    fill: "#1AC463"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.88,
    y: 51.4106,
    width: 19.2,
    height: 19.2,
    transform: "rotate(-41.7611 26.88 51.4106)",
    fill: "#1AC463"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.7903,
    y: 74.3601,
    width: 19.2,
    height: 23.04,
    transform: "rotate(-41.7611 47.7903 74.3601)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47.7903,
    y: 74.3601,
    width: 19.2,
    height: 23.04,
    transform: "rotate(-41.7611 47.7903 74.3601)",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7904 74.36L63.1356 91.5462L77.4574 78.7584L62.1122 61.5723L47.7904 74.36Z",
    fill: "url(#paint6_linear_115_811)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3479,
    y: 77.2241,
    width: 73.9949,
    height: 19.2,
    transform: "rotate(-41.7611 50.3479 77.2241)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_811",
    x1: 51.264,
    y1: 139.872,
    x2: 51.264,
    y2: 42.0669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04364C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#033448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#033245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#022737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_115_811",
    x1: 79.1232,
    y1: 191.942,
    x2: 79.1232,
    y2: 65.7983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04364C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#033448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#033245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#022737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#022331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_115_811",
    x1: 135.936,
    y1: 132.384,
    x2: 135.936,
    y2: 142.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_115_811",
    x1: 86.0544,
    y1: 132.384,
    x2: 86.0544,
    y2: 142.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_115_811",
    x1: 58.2144,
    y1: 132.384,
    x2: 58.2144,
    y2: 142.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_115_811",
    x1: 158.093,
    y1: 99.0913,
    x2: 113.76,
    y2: 99.0913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E6E7E8",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E6E7E8",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E7E8E9",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E8E9EA",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E9EAEB",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EBECEC",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ECEDEE",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#EEEFF0",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#F1F2F2",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F2F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_115_811",
    x1: 70.2903,
    y1: 85.1578,
    x2: 54.9451,
    y2: 67.9717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E7E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoster192);
export default __webpack_public_path__ + "static/media/Roster-192.78e059fbca9b454fb1c13840950d6b35.svg";
export { ForwardRef as ReactComponent };